function initSwiperSliders(root) {
  root.querySelectorAll('.swiper-slider').forEach((el) => {
    if (el.swiperInstance || typeof Swiper === 'undefined') return;

    const slidesDesktop = Number(el.dataset.slidesDesktop) || 1;
    const slidesMobile = Number(el.dataset.slidesMobile) || 1;
    const spaceBetween = Number(el.dataset.spaceBetween) || 0;
    const loop = el.dataset.loop === 'true' && el.querySelectorAll('.swiper-slide').length > 1;
    const autoplay = el.dataset.autoplay === 'true';
    const autoplaySpeed = Number(el.dataset.autoplaySpeed) || 5000;
    const paginationEl = el.querySelector('.swiper-pagination');
    const nextEl = el.querySelector('.swiper-button-next');
    const prevEl = el.querySelector('.swiper-button-prev');
    const autoHeight = el.dataset.heightMode === 'adapt';

    el.swiperInstance = new Swiper(el, {
      slidesPerView: slidesMobile,
      spaceBetween,
      loop,
      autoHeight,
      autoplay: autoplay ? { delay: autoplaySpeed, disableOnInteraction: false } : false,
      pagination: paginationEl
        ? { el: paginationEl, clickable: true, type: el.dataset.paginationType || 'bullets' }
        : false,
      navigation: nextEl && prevEl ? { nextEl, prevEl } : false,
      breakpoints: {
        750: {
          slidesPerView: slidesDesktop,
        },
      },
    });
  });
}

function destroySwiperSliders(root) {
  root.querySelectorAll('.swiper-slider').forEach((el) => {
    if (el.swiperInstance) {
      el.swiperInstance.destroy(true, true);
      el.swiperInstance = null;
    }
  });
}

document.addEventListener('DOMContentLoaded', () => initSwiperSliders(document));

if (Shopify && Shopify.designMode) {
  document.addEventListener('shopify:section:load', (event) => initSwiperSliders(event.target));
  document.addEventListener('shopify:section:unload', (event) => destroySwiperSliders(event.target));
}
